module.exports = __webpack_public_path__ + "img/2165aczHJCbbzJh.6fe8e465.jpg";